import { cn } from '../../cn';
import { Tooltip } from '../../ui/tooltip';
import { ProjectTypeSymbol } from '@/utils/ProjectTypeSymbol';
import type { TypeMarkView } from '../model/projectView';

/**
 * Значок типа проекта (концепт list-type-icon 1.2): квадрат 1:1 с символом типа из таблицы,
 * заливка и текст — как у бейджа типа (22 % / 55 % цвета типа).
 * decorative — рядом уже написано название типа (пункт меню): значок без подсказки и скрыт от диктора.
 */
export function ProjectTypeMark({ mark, decorative = false, className }: { mark: TypeMarkView; decorative?: boolean; className?: string }) {
  const square = (
    <span
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': mark.text })}
      style={{
        backgroundColor: `color-mix(in oklab, ${mark.color} 22%, var(--card))`,
        color: `color-mix(in oklab, ${mark.color} 55%, var(--foreground))`,
      }}
      className={cn(
        'nd:grid nd:size-4 nd:shrink-0 nd:place-items-center nd:rounded-[0.25rem] nd:text-[0.625rem] nd:leading-none nd:font-bold nd:tracking-[-0.01em]',
        className
      )}
    >
      <ProjectTypeSymbol symbol={mark.label} />
    </span>
  );
  return decorative ? square : <Tooltip label={mark.text}>{square}</Tooltip>;
}
